import { Table, Button, Pagination, ButtonGroup } from "flowbite-react";
import { HiPlus, HiPencil } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import { routes } from "../routes";
import { useReducerAsState } from "../hooks/useReducerAsState";
import usePages from "../hooks/usePages";
import { TableResults } from "../components";

interface State {
    page: number;
    limit: number;
}

const PagesPage = () => {
    const { pages, loading, error, totalPages, fetchPages } = usePages()
    const [state, setState] = useReducerAsState<State>({
        page: 1,
        limit: 10
    })

    const navigate = useNavigate();

    const onPageChange = (page: number) => setState({page})

    const handleCreate = () => navigate(`${routes.DASHBOARD}/${routes.PAGES}/create`)

    useEffect(() => {
        (async () => {
            await fetchPages({...state})
        })()
        // eslint-disable-next-line
    },[])

    return <div className="m-4">
        <div className="flex flex-col mb-4">
            <div className="mb-4">
                <h1>Páginas Estáticas</h1>
            </div>
            <div className="flex flex-row justify-between items-end">
                <div className="flex flex-row">
                    <Button onClick={handleCreate}>
                        <HiPlus className="mr-2 h-5 w-5" />
                        Crear Página
                    </Button>
                </div>
            </div>
        </div>
        <TableResults
            loading={loading}
            error={error}
            itemsCount={totalPages}
        >
            <div className="overflow-x-auto mb-4 w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
                <Table>
                    <Table.Head>
                        <Table.HeadCell>Título</Table.HeadCell>
                        <Table.HeadCell></Table.HeadCell>
                    </Table.Head>
                    <Table.Body className="divide-y">
                        {pages && pages.map((item) => <Table.Row key={item.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                            <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                {item.title}
                            </Table.Cell>
                            <Table.Cell>
                            <ButtonGroup>
                                    <Button onClick={() => navigate(`${routes.DASHBOARD}/${routes.PAGES}/${item.id}`)} color="gray">
                                        <HiPencil />
                                    </Button>
                            </ButtonGroup>
                            </Table.Cell>
                        </Table.Row>)}
                    </Table.Body>
                </Table>
            </div>
        </TableResults>
        {pages && <div className="flex overflow-x-auto sm:justify-center">
            <Pagination currentPage={state.page} totalPages={Math.ceil(totalPages / state.limit)} onPageChange={onPageChange} />
        </div>}
    </div>
}

export default PagesPage;